import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import style from "./Execution.module.scss";

export default ({ logs }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (logs) {
    }
  }, []);

  if (!logs) {
    return null;
  }

  return (
    <div>
      <Button color="link" className="p-0 pb-1" tabIndex="-1" onClick={() => setOpen(!open)}>
        {open ? (
          <React.Fragment>
            <i className="fa fa-chevron-down mr-1" /> Hide selecteds routes logs
          </React.Fragment>
        ) : (
          <React.Fragment>
            <i className="fa fa-chevron-right mr-1" />
            View selected routes logs
          </React.Fragment>
        )}
      </Button>

      {open && (
        <div className={style.routesLogs}>
          {logs.map((value, index) => (
            <div key={index} className={style.row}>
              <small className={getClassTitle(value.key)}>{value.key}</small>
              <span style={{ display: "block", fontSize: 13 }}>{value.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

function getClassTitle(key) {
  if (key.match(/candidate discarded/i)) {
    return "text-danger";
  }
  if (key.match(/candidate with warning/i)) {
    return "text-warning";
  }
  if (key.match(/candidate/i)) {
    return "text-buy";
  }
  return "text-primary";
}
